import { type FunctionalComponent, h } from '@stencil/core';
import type { IHorizontalFilters } from '../../types/subcomponents-types.type';

export const HorizontalFilters: FunctionalComponent<IHorizontalFilters> = ({ ...props }) => {
    return (
      props.horizontalFilterPanel ?
        (<div class="filter-chips-container">
          {props.filtersChips.map(filterChip => (
            <svs-chip
              class="filter-chip"
              name={`${props.labelProvider(filterChip.facetType, filterChip.facetType)}: ${filterChip.value}`}
              onClick={()=>{
                  props.facetChanged.emit({
                    facetValue: filterChip.facetValue,
                    facetType: filterChip.facetType,
                    facetName: filterChip.facetName,
                    facetCount: filterChip.facetCount,
                    facetQuery: filterChip.facetQuery,
                    value: filterChip.facetValue,
                    action: 'remove',
                    id: filterChip.id,
                    dateFacetType: filterChip.dateFacetType,
                  });
              }}></svs-chip>))}
          {props.filtersChips.length > 0 ?
            <uiaas-search-reset-all-button
              horizontalFilterPanel={props.horizontalFilterPanel}
              disabledButton={props.disableFiltersOnLoading ? props.reflectedState.ajaxIsLoading : false}
              labelProvider={(e, f) => props.labelProvider(e, f)}
            /> : ''}
        </div>) : ''
    );
};
